import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import api2 from "../../../Component/axios_Interceptor/api2";
import { Live } from "../../../Component/Interface/Live";
import url from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import {
  RowView,
  RowView2,
  TitleArea,
} from "../../../Component/style/common_style";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import PagingControl from "../../../Component/UI/PagingControl";
import api from "../../../Component/axios_Interceptor/api";

const Livelist = () => {
  const Navigate = useNavigate();

  const [cnt, setCnt] = useState(0);
  const [livelist, setLivelist] = useState<Live[]>([]);
  const [currentPage, setCurrentPage] = useState(1);

  const get_live_list = async () => {
    try {
      const res = await api.get(url.Communication_url.get_live_list, {
        params: { currentPage: currentPage, perPage: 20, sort: "ASC" },
      });
      setLivelist(res.data.liveList || []);
      setCnt(res.data.total || 0);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };
  useEffect(() => {
    get_live_list();
  }, [currentPage]);

  // 요일 반환
  const Dow = (date: string) => {
    const idx = new Date(date).getDay();
    return ["일", "월", "화", "수", "목", "금", "토"][idx];
  };

  const go_livemake = () => Navigate("make");

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  // 라이브 취소
  const live_cancel = async (seq: number) => {
    if (window.confirm("정말로 취소하시겠습니까?")) {
      try {
        const res = await api.post(url.Communication_url.live_cancel, {
          seq: seq,
        });
        if (res.data === "성공") {
          get_live_list();
        }
      } catch (error) {
        console.error("취소 실패:", error);
      }
    }
  };
  return (
    <Layout_Admin menuname={"라이브 목록"}>
      <TitleArea>
        <div>라이브 목록</div>
      </TitleArea>

      <RowView2 className="end">
        <Btn onClick={go_livemake}>라이브 만들기</Btn>
      </RowView2>

      <Table className="header">
        <div className="time">예약일시</div>
        <div className="title">라이브 제목</div>
        <div>라이브 시간</div>
        <div>수용인원</div>
        <div>라이브상태</div>
        <div></div>
      </Table>

      {livelist.map((data, idx) => {
        const date = data.live_start.slice(0, 10).replaceAll("-", ".");
        const time = data.live_start.slice(11, 16);

        const liveStart = new Date(data.live_start);
        const liveFinish = new Date(data.live_finish);

        const timeDifference = liveFinish.getTime() - liveStart.getTime();
        const hour = timeDifference / (1000 * 60 * 60);

        return (
          <Table
            className="pointer"
            key={idx}
            onClick={() => Navigate(`${data.seq}`)}
          >
            <div className="time">
              {date}({Dow(date)}) {time}
            </div>
            <div className="title">{data.live_title}</div>
            <div>{hour}시간</div>
            <div>{data.live_limit}명</div>
            <div>{data.live_status}</div>
            <div onClick={stopPropagation}>
              {data.live_status === "예약" && (
                <CancelBtn
                  style={{ display: "flex" }}
                  onClick={() => {
                    live_cancel(data.seq);
                  }}
                >
                  취소
                </CancelBtn>
              )}
            </div>
          </Table>
        );
      })}

      <PagingControl
        cnt={cnt}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </Layout_Admin>
  );
};

export default Livelist;

const Btn = styled.div`
  padding: 0.65rem 1.5rem;
  margin-bottom: 1rem;
  ${fontStyles.medium}
  font-size: 16px;
  color: white;
  background: linear-gradient(135deg, #7955f0, #3209b9);
  border-radius: 4px;
  cursor: pointer;
`;
const Table = styled(RowView)`
  padding: 1rem 0rem;
  ${fontStyles.medium}
  border-bottom: 2px solid #f8f8f8;
  &.header {
    padding: 0.8rem 0rem;
    background-color: #f8f8f8;
  }
  div {
    flex: 1;
    margin: 0rem 0.5rem;
    text-align: center;
    max-height: 2.5rem;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  div.time {
    flex: 2;
  }
  div.title {
    flex: 3;
  }
  &.pointer {
    height: 34px;
  }
`;

const CancelBtn = styled.div`
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  width: 50px;
  height: 32px;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-justify: center;
  font-size: 14px;
  color: #8e8e8e;
  font-family: var(--font-Pretendard-Medium);
`;
